// @flow

import Unit from '@/lib/unit';

// (Cell の残日光量）* (1 - exp(-KF))
// Cell の残日光量: 0 ~ 100
// K: 0 ~ 22 (K=22, F=1.0 の時に 100% の日光量を吸収してしまうため)
// F: 0.0 ~ 1.0
export default class {
  static process(unit: Unit) {
    if (!unit.template.categories.includes('tree')) return;

    const constants = unit.template.constants || {};
    const k = constants.k || 1;
    const f = unit.treeHeight / (unit.template.maxHeight || 1);
    const sunlight: number = unit.getParameter('cell', 'sunlight');
    const absorbedSunlight = sunlight * (1 - Math.exp(-k * f));
    unit.treeSunlight = absorbedSunlight;
    unit.cell.update('sunlight', -absorbedSunlight, 1);
  }
}



// WEBPACK FOOTER //
// ./src/lib/unit_event/absorb_sunlight_event.js